import { PaymentInterval } from '@/shared/types/Billing';
import { User } from '@/shared/types/User';

export const getPlanPeriodLabel = (user: null | User) => {
  const period = user?.subscription?.plan.interval;

  return period === PaymentInterval.Year ? 'Annually' : 'Monthly';
};
